import { Navigate, Route, Routes } from "react-router-dom";

import SmsSimulatorRules from "containers/sms-simulator/sms-simulator-rules/sms-simulator-rules";
import SmsSimulatorPersonas from "containers/sms-simulator/sms-simulator-personas/sms-simulator-personas";
import SmsSimulatorSimulations from "containers/sms-simulator/sms-simulator-simulator/sms-simulator-simulations";

import { Route as AppRoute } from "utilities/app-routes";

const SmsSimulatorRoutes = () => (
  <Routes>
    <Route index element={<Navigate to={AppRoute.rules} />} />
    <Route path={AppRoute.rules + "/*"} element={<SmsSimulatorRules />} />
    <Route path={AppRoute.personas + "/*"} element={<SmsSimulatorPersonas />} />
    <Route path={AppRoute.simulator + "/*"} element={<SmsSimulatorSimulations />} />
  </Routes>
);

export default SmsSimulatorRoutes;
